import { RegisterableHotkey } from '@tanstack/react-hotkeys';
import { isNil } from 'lodash';
import { HotkeyActionId } from './hotkeyActions';
import { useHotkeyOverrides } from './hotkeySettings';
import { useHotkeyActions } from './useHotkeyActions';
import { useHotkeyCustomizationEnabled } from './useHotkeyCustomizationEnabled';

/**
 * Resolves an action id to the user's keybinding, or its default. Actions
 * outside the current experience's set resolve to null, and overrides only
 * apply while the customization flag is on.
 */
export function useHotkeyBinding(actionId: HotkeyActionId): RegisterableHotkey | null {
  const customizationEnabled = useHotkeyCustomizationEnabled();
  const actions = useHotkeyActions();
  const [overrides] = useHotkeyOverrides();

  const action = actions[actionId];
  if (isNil(action)) {
    return null;
  }
  if (customizationEnabled && actionId in overrides) {
    return overrides[actionId] ?? null;
  }
  return action.defaultHotkey ?? null;
}
